import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import useValue from "./useValue";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { valueFields, handleSubmit, setData, setErrors } = useValue();
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const { id } = useParams();

  const addAttributeValue = data => {
    axios.post('attributes/' + id + '/values', data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Attribute value has been created successfully!', {
            icon: "success",
          });
          navigate(-1);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add Value">
      <form className="form w-100 row" onSubmit={handleSubmit(addAttributeValue)}>
        {valueFields}
        <SubmitButton
          title="Add"
          classes="w-auto d-inline-block float-right"
        />
      </form>
    </Card>
  );
}